import { render, staticRenderFns } from "./buySell.vue?vue&type=template&id=1e11c8a6&scoped=true&"
var script = {}
import style0 from "./buySell.vue?vue&type=style&index=0&id=1e11c8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e11c8a6",
  null
  
)

export default component.exports